import { styled } from '@mui/material';
import React from 'react';
import ReactQuill from 'react-quill';

export interface TextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const TextEditor: React.FC<TextEditorProps> = ({ value, onChange, placeholder }) => {
  return (
    <ReactQuillStyled
      placeholder={placeholder || 'Email message'}
      value={value}
      onChange={(value) => onChange(value)}
    />
  );
};

const ReactQuillStyled = styled(ReactQuill)`
  border: 0.5px solid #d7d7d7;
  border-radius: 3px;

  > div.ql-toolbar.ql-snow {
    border-radius: 3px 3px 0 0;
  }

  > div.ql-container.ql-snow {
    border-radius: 0 0 3px 3px;

    > .ql-editor.ql-blank::before {
      color: rgba(57, 60, 73, 0.3);
    }
  }
`;
